export const Points = (props: any) => {
  const { data ,name} = props;
  return (
    <div className="col-sm-4 mt-5">
      <h4>{name}</h4>
      <table className="table table-striped border-0 mt-4">
        {data.length > 0 && (
          <tbody>
            {data.map((el: any, index: number) => {
              return (
                <tr>
                  {index + 1}. {el}
                </tr>
              );
            })}
          </tbody>
        )}
      </table>
    </div>
  );
};
